import {each} from 'lodash';
import Swiper from 'swiper/bundle';
import { media, media_expression } from '../../utils/media';

export default class GalleryProduct {
    constructor() {
        this.gallery = {
            container: document.querySelector('[data-gallery]'),
        }

        this.carousel = {
            init: false,
            object: undefined,
            element: document.querySelector('.carousel[data-carousel="gallery-product"]'),
        }

        this.createCarousel(this.carousel.element); // Init Carousel
        window.addEventListener('resize', this.onResize);

    }

    createCarousel(target){
        if(media('<=iPadPortrait')) {
            if (!this.carousel.init) {
                this.carousel.init = true;

                this.carousel.object = new Swiper(this.carousel.element, {
                    slidesPerView: 1,
                    spaceBetween: 0,
                    // loop: true,
                    // centeredSlides: true,
                    navigation: false,
                    grabCursor: true,
                    scrollbar: {
                        el: ".swiper-scrollbar",
                        draggable: true,
                    },
                });
                
            }
        } else if(media('>iPadPortrait')) {
            this.carousel.init = false;

            if(this.carousel.object) { 
                this.carousel.object.destroy() 
            }
        }
    }

    onResize = () => {
        this.createCarousel(this.carousel.element);
    }
}